import React from "react";
// import powerBall from "../../assets/unique/projects/Powerball.png";
// import Oasis from "../../assets/unique/projects/Oasis.png";
// import Xpheres from "../../assets/unique/projects/Xpheres.png";
// import Rebel from "../../assets/unique/projects/Rebel.png";
import NFT from "../../assets/unique/dynamicNFT.png";
import MNFT from "../../assets/unique/dinamicNFTMobile.png";

function Content() {
  // const project = [
  //   {
  //     cover: powerBall,
  //   },
  //   {
  //     cover: Oasis,
  //   },
  //   {
  //     cover: Xpheres,
  //   },
  //   {
  //     cover: Rebel,
  //   },
  // ];
  return (
    <div className="flex md:flex-col h-full px-5">
      <div className="flex flex-col-reverse md:flex-row justify-center items-center h-full">
        <div className="md:w-[40%] px-10 h-[55%] justify-center text-left self-end mb-[4rem] sm:h-auto">
          <div className="text-white font-bold md:text-[24px] text-left">
            DYNAMIC NFTs
          </div>
          <div className="text-white text-sm font-normal md:text-lg py-5 lg:break-words lg:w-[90%]">
            Dynamic NFTs (dNFTs) are expanding the design space of traditional
            NFTs. dNFTs is the new format that allows NFTs to adapt and change
            in response to external events and data.
          </div>
          {/* <div className="flex flex-row">
            <div className="text-white font-bold rounded-lg border text-left p-5">
              APPLICATION
              <div className="grid grid-cols-2 gap-2 items-center mix-blend-lighten">
                {project &&
                  project.map((item, index) => (
                    <img
                      src={item.cover}
                      alt=""
                      className="w-full"
                      key={index}
                    />
                  ))}
              </div>
            </div>
          </div> */}
        </div>

        <div className="md:w-[40%] flex justify-center items-center px-10 h-[30%]">
          <div className="md:hidden">
            <img src={MNFT} alt="" className="h-44 my-10" />
          </div>
          <div className="hidden md:block">
            <img src={NFT} alt="" className="w-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
export default Content;
